angular.module("questionarioClientela.components", []).component("questionarioClientela", {
    templateUrl: "ng/components/richiestaCessione/questionarioClientela/questionarioClientela.view.html",
    bindings: {
        isRichiestaVoltura: "=",
        isRichiestaCessione: "=",
        model: "<",
        exportValidity: "&",
        readOnly: "=",
        idWf: "="
    },
    controllerAs: "questionarioClientelaCtrl",
    controller: function QuestionarioClientela(
        $modalService,
        $timeout,
        $RichiestePostVenditaService,
        $location
    ) {
        var self = this;

        self.$onInit = function () {
            self.numberOfQuestionsSelected = 0;
            self.numberOfCheckSelected = [];
            self.numberOfRadioSelected = [];
            self.currentQuestion = "";
            self.supportModel = {
                enableModal: false,
                enableConfButton: false,
                qva: {},
                qvaList: [],
                idRichiesta: 0,
                messaggioWarning: ""
            }

            if (self.model.questionarioQva[0].domande.length) {
                self.supportModel.qva.domande = self.model.questionarioQva[0].domande
                self.count(self.model.questionarioQva[0].domande);
                controlChek();
                controlRadio();
                checkIfIseveryQuestionAnswered();
                checkValidityComponent();
            }
        }

        self.openModal = function (qva, index) {
            self.openingModal = true;
            self.supportModel.enableModal = true;
            self.supportModel.idRichiesta = index;
            self.supportModel.qva = qva;

            $timeout(function () {
                $modalService.openModal("qvaCessionarioModal");
                $('.financial-leasing__footer').css("z-index", "-1");
                self.openingModal = false;
            }, 500);
        }

        self.closeModal = function () {
            if (self.supportModel.qva.esito == null) {
                self.supportModel.enableConfButton = false;
            }

            $('.financial-leasing__footer').css("z-index", "1");
            $modalService.closeModal();
            self.supportModel.enableModal = false;
        };

        self.closeIncorrectModal = function () {
            $modalService.closeModal("incorrectQvaModal");
        };

        self.saveQva = function () {
            self.savingQva = true;
            $RichiestePostVenditaService.validateQvaPv(self.supportModel.qva.domande, self.supportModel.qva.codQuestionario,
                    self.supportModel.qva.prodotto, self.supportModel.qva.contratto, self.supportModel.qva.modulo, self.idWf)
                .then(function (response) {
                    self.supportModel.qva.esito = response.esito;
                    if (self.supportModel.qva.esito === "A") {
                        self.model.questionarioQva[self.supportModel.idRichiesta].esito = self.supportModel.qva.esito;
                        self.model.questionarioQva[self.supportModel.idRichiesta].questCompleto = true;
                        if(self.isRichiestaCessione) {
                            self.model.questComplete = true;
                        }
                        $('.financial-leasing__footer').css("z-index", "1");
                        $modalService.closeModal("qvaCessionarioModal");
                        self.supportModel.enableModal = false;
                    } else if (response.esito == "NR") {
                        self.supportModel.messaggioWarning = response.warningEsito;
                        $modalService.openModal("qva-modal-1");
                    } else {
                        self.supportModel.messaggioWarning = response.warningEsito;
                        $modalService.openModal("incorrectQvaModal");
                    }
                    checkValidityComponent();
                    self.savingQva = false;
                })
                .catch(function (error) {
                    self.savingQva = false;
                    console.log(error);
                })
        }

        var checkValidityComponent = function () {
            var testQva = false;

            testQva = self.model.questionarioQva.every(function (qva) {
                return qva.questCompleto;
            });

            if (testQva) {
                self.exportValidity({
                    validity: true
                });
            } else {
                self.exportValidity({
                    validity: false
                });
            }
        }

        self.check = function (el) {
            el.selected = !el.selected;
            controlChek();
        }

        var controlChek = function () {
            self.numberOfCheckSelected = [];
            self.supportModel.qva.domande
                .filter(function (element) {
                    return element.tipo == "checkbox"
                }).forEach(function (f, index) {
                    self.numberOfCheckSelected[index] = f.risposte.some(function (s) {
                        return s.selected == true
                    })
                })
            checkIfIseveryQuestionAnswered();
        }

        var controlRadio = function () {
            self.numberOfRadioSelected = [];
            self.supportModel.qva.domande
                .filter(function (element) {
                    return element.tipo == "radio"
                }).forEach(function (f, index) {
                    self.numberOfRadioSelected[index] = f.risposte.some(function (s) {
                        return s.selected == true
                    })
                })
            checkIfIseveryQuestionAnswered();
        }

        self.updateSelectedAnswer = function (indexAns, indexQue) {
            self.supportModel.qva.domande[indexQue].risposte[indexAns].selected = true;

            self.supportModel.qva.domande[indexQue].risposte.forEach(function (r) {
                if (r != self.supportModel.qva.domande[indexQue].risposte[indexAns]) {
                    r.selected = false;
                }
            })

            self.numberOfRadioSelected = [];
            self.supportModel.qva.domande
                .filter(function (element) {
                    return element.tipo == "radio"
                }).forEach(function (f, index) {
                    self.numberOfRadioSelected[index] = f.risposte.some(function (s) {
                        return s.selected == true
                    })
                })

            checkIfIseveryQuestionAnswered();
        }

        var checkIfIseveryQuestionAnswered = function () {
            var allQuestionChecked = self.numberOfCheckSelected
                .every(function (e) {
                    return e == true;
                })
            var allQuestionRadio = self.numberOfRadioSelected
                .every(function (e) {
                    return e == true;
                })
            var totalNumberOfRadio = self.supportModel.qva.domande &&
                self.supportModel.qva.domande
                .filter(function (element) {
                    return element.tipo == "radio"
                })

            var totalNumberOfCheck = self.supportModel.qva.domande &&
                self.supportModel.qva.domande
                .filter(function (element) {
                    return element.tipo == "checkbox"
                })
            if (allQuestionRadio && allQuestionChecked && (self.numberOfCheckSelected.length == totalNumberOfCheck.length) && (self.numberOfRadioSelected.length == totalNumberOfRadio.length)) {
                self.supportModel.enableConfButton = true;
            } else {
                self.supportModel.enableConfButton = false;
            }
        }

        self.count = function (domande) {
            domande.forEach(function (domanda) {
                domanda.risposte.forEach(function (risposta) {
                    if (risposta.selected === true) {
                        self.numberOfQuestionsSelected = self.numberOfQuestionsSelected + 1;
                    }
                })
            })
        }

        self.goHome = function () {
            $location.path("/");
        }
    }
})